import React, { useMemo, useState } from "react";
import Slider from "react-slider";

const LdsContentSlider = ({ contentItems, containerClassName, label, id }) => {
  const [contentItemIndex, setContentItemIndex] = useState(0);

  const validatedSetContentItemIndex = (index) => {
    if (index < 0) {
      setContentItemIndex(0);
    } else if (index >= contentItems.length) {
      setContentItemIndex(contentItems.length - 1);
    } else {
      setContentItemIndex(index);
    }
  };

  const contentItem = useMemo(() => {
    return contentItems[contentItemIndex];
  }, [contentItemIndex, contentItems]);

  return (
    <div className={`content-slider ${containerClassName || ""}`}>
      <div>{contentItem}</div>
      <div className="content-slider-input-container">
        <div
          className="content-slider-input-wrapper"
          style={{ width: `${40 * ((contentItems?.length || 0) + 1)}px` }}
        >
          <Slider
            className="content-slider-input"
            defaultValue={contentItemIndex}
            withBars
            min={0}
            max={contentItems.length - 1}
            step={1}
            onChange={validatedSetContentItemIndex}
            marks={1}
            renderMark={({ key, className, ...rest }) => {
              return (
                <div
                  className={`content-slider-input-mark ${className} ${key > contentItemIndex ? "mark-1" : "mark-0"}`}
                  key={key}
                  {...rest}
                />
              );
            }}
          />
        </div>
        <label htmlFor={id || "slider"} className="fz-sm dark-gray">
          {label}
        </label>
      </div>
    </div>
  );
};

export default LdsContentSlider;
